/* eslint-disable no-shadow */
import {
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const SkeletonTable = () => {
  const rows = 10;
  const columns = 10;

  return (
    <TableContainer component={Paper} sx={{ maxHeight: 600, overflow: "auto" }}>
      <Table sx={{ minWidth: 1200, border: "1px solid #D9DBE9" }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: 180, border: "1px solid #D9DBE9" }}>
              <Skeleton variant='text' width={120} height={15} />
            </TableCell>
            {[...Array(columns - 1)].map((_, index) => (
              <TableCell
                key={index}
                sx={{ width: 100, border: "1px solid #D9DBE9", textAlign: "center" }}>
                <Skeleton variant='text' width={80} height={15} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(rows)].map((_, rowIndex) => (
            <TableRow key={rowIndex}>
              <TableCell sx={{ border: "1px solid #D9DBE9" }}>
                <Skeleton variant='text' width={120} height={20} />
              </TableCell>
              {[...Array(columns - 1)].map((_, colIndex) => (
                <TableCell key={colIndex} sx={{ border: "1px solid #D9DBE9", textAlign: "center" }}>
                  <Box display='flex' justifyContent='center' alignItems='center' height={20}>
                    <Skeleton variant='rectangular' width={20} height={20} />
                  </Box>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SkeletonTable;
